import { array, func } from 'prop-types'
import { useState } from 'react'
import { UnwrappedButton } from '../Button'
import Menu from '../Menu'
import Dropdown from '../PopoverV2/Dropdown'
import { kuiperClassNames } from '../utils/kuiperClassNames'

import './styles.scss'

const renderPopoverContent = (onSelect, services = []) => (
  <Menu
    className="add-content_channel-list"
    canSelectAll={false}
    focusOnMount={true}
    minimumSearchLength={1}
    multiple={false}
    options={services}
    onSelect={(service) => onSelect(service.value)}
    role="listbox"
    searchable={true}
    showControls={false}
    value={[]}
  />
)

const renderPopoverTrigger = () => (
  <UnwrappedButton
    className={kuiperClassNames('add-content')}
    label="Add Content"
    position="left"
    type="primary"
    icon="plus-solid"
    onClick={(e) => {
      e.stopPropagation()
    }}
    size="wide"
    typeAttribute="button"
  />
)

const AddContentButton = ({ onSelect, services }) => {
  // The dropdown is interactive, so a click on a channel does not close it.
  // Left open, the next click on the trigger closes the stale menu instead of
  // opening a fresh one, and no further content can be added.
  const [shouldCloseMenu, setShouldCloseMenu] = useState(false)

  const selectChannel = (service) => {
    setShouldCloseMenu(true)
    onSelect(service)
  }

  return (
    <Dropdown
      className={kuiperClassNames('addContentButton')}
      content={renderPopoverContent(selectChannel, services)}
      edgeOffset={0}
      forceClose={shouldCloseMenu}
      onClosed={() => setShouldCloseMenu(false)}
      position="bottom"
      trigger={renderPopoverTrigger()}
    />
  )
}

AddContentButton.propTypes = {
  onSelect: func,
  services: array,
}

export default AddContentButton
